import React from "react";
import { View, StyleSheet } from "react-native";
import NtListRow from "../../components/NtListRow";

function NtDidItem({ item, columns }) {
  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(item, column) => {
          if (column == "status") {
            return item[column] == 1 ? "Active" : "Inactive";
          } else if (column == "primary") {
            return item[column] == 1 ? "Primary" : "Secundary";
          }
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtDidItem;
